import { useState } from 'react';

export function TeamBadge({ name, imageUrl, size = 'md' }: { name: string; imageUrl?: string; size?: 'sm' | 'md' | 'lg' }) {
  const [failed, setFailed] = useState(false);
  const initials = name.split(/\s+/).slice(0, 2).map((part) => part[0]).join('').toUpperCase();
  return <span className={`team-badge team-badge--${size} ${imageUrl && !failed ? 'has-emblem' : ''}`}>
    {imageUrl && !failed
      ? <img src={imageUrl} alt={`Emblema de ${name}`} loading="lazy" referrerPolicy="no-referrer" onError={() => setFailed(true)} />
      : <b>{initials}</b>}
  </span>;
}
